import React from 'react'
import { Loading } from '@myxplor/ui'

import LocalAsyncStore from '../../../local-async-store'
import GovPersonnelView from './views'

export const GovPersonnel = ({ personnel, base_url, gov_registrations }) =>
  gov_registrations.loading ? (
    <Loading title="Loading matching government personnel records" />
  ) : (
    <GovPersonnelView
      personnel={personnel}
      base_url={base_url}
      gov_registrations={gov_registrations.data}
    />
  )

export default LocalAsyncStore(
  'gov_registrations',
  GovPersonnel,
  ({ base_url, personnel }) => `/api${base_url}/${personnel.id}/gov-person-registrations`
)



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/container.js